import React, { useEffect, useState, useContext, useRef } from 'react';

import BnplLoading from './BnplLoading';

import Info from '../../assets/images/info.svg';

/** context */
import { UserContext } from '../../context/UserContext';

/** service */
import { updateApplication, validateProperty } from '../../service/api';

export default function BnplCardPayment({ className, gotoNextStep }) {
  const { appData, updateAppData, setLoading } = useContext(UserContext);
  const [collectJsLoader, setCollectJsLoader] = useState(true);
  const [collectJsInstance, setCollectJsInstance] = useState({});
  const tokenizedPaymentFeature = appData?.applicationFeatures?.find(
    (feature) => feature.itemType === 'TokenizedPaymentProperty'
  );

  const cvvRef = useRef(null);
  const ccexpRef = useRef(null);
  const ccnumberRef = useRef(null);

  const payment = 1000;
  const [data, setData] = useState({
    name: '',
    lastName: '',
    amount: payment,
    isSubmitting: false,
  });
  const [error, setError] = useState('');
  const [dataError, setDataError] = useState({});

  useEffect(() => {
    const interval = setTimeout(() => {
      if (!Object.keys(collectJsInstance).length) {
        window.location.reload();
      }
    }, 50);
    return () => clearTimeout(interval);
  }, [collectJsInstance]);

  useEffect(() => {
    if (window.CollectJS) {
      setCollectJsInstance(window.CollectJS);
      window.CollectJS.configure({
        variant: 'inline',
        styleSniffer: true,
        validationCallback: (field, valid, message) => {
          console.log(field, valid, message);
          if (valid) {
            setDataError((dataError) => ({
              ...dataError,
              [field]: '',
            }));
          } else {
            setDataError((dataError) => ({
              ...dataError,
              [field]: message,
            }));
            setLoading(false);
          }
        },
        timeoutDuration: 5000,
        timeoutCallback: () => {
          console.log('collectJS API call timeout');
          setLoading(false);
        },
        fieldsAvailableCallback: () => {
          setCollectJsLoader(false);
          cvvRef.current.children[0].style.height = '61px';
          ccnumberRef.current.children[0].style.height = '61px';
          ccexpRef.current.children[0].style.height = '61px';
        },
        callback: (token) => {
          console.log('token', token);
          setData({
            ...data,
            isSubmitting: false,
          });
          finishSubmit(token);
        },
        googleFont: 'Lato:400',
        invalidCss: {
          color: '#161E33',
          'background-color': 'rgba(243, 106, 63, 0.05)',
          border: '1px solid #F36A3F',
        },
        validCss: {
          color: '#161E33',
          'background-color': '#fff',
        },
        placeholderCss: {
          color: '#161E33',
          'background-color': 'transparent',
        },
        focusCss: {
          color: '#161E33',
          'background-color': '#fff',
        },
        customCss: {
          // 'margin-top': '20px',
          'margin-bottom': '20px',
          'font-weight': '500',
          'font-size': '16px',
          'line-height': '150%',
          height: '41px',
        },
        fields: {
          ccnumber: {
            title: 'Card Number',
            selector: '#ccnumber',
            placeholder: '**** **** **** ****',
          },
          ccexp: {
            title: 'Exp. Date',
            selector: '#ccexp',
            placeholder: '** / **',
          },
          cvv: {
            title: 'CVV2',
            selector: '#cvv',
            placeholder: '***',
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const finishSubmit = async (response) => {
    console.log('finishSubmit', response);
    const { isSubmitting, ...formData } = { ...data };
    formData.token = response.token;
    console.log(formData);
    setData({
      ...data,
      isSubmitting: false,
    });
    // gotoNextStep();

    if (response.token) {
      try {
        const updatedData = await updateApplication([
          {
            itemType: tokenizedPaymentFeature.itemType,
            dataType: tokenizedPaymentFeature.dataType,
            name: tokenizedPaymentFeature.name,
            value: {
              binNumber: response.card.bin,
              token: response.token,
              paymentType: response.card.type,
              maskedPaymentIdentifier: response.card.number.slice(-4),
            },
          },
        ]);

        if (updatedData.data) {
          updateAppData(updatedData.data);
        }

        const validationData = await validateProperty(tokenizedPaymentFeature.name);

        setLoading(false);

        if (validationData.data && validationData.data.errors) {
          if (validationData.data.errors.length) {
            validationData.data.errors.map((error) => {
              const attributes = error.property.split('.');
            });
            return false;
          }
        }
      } catch (error) {
        const errors = error.response.data.errors;
        console.log(errors);
        if (errors.length) {
          setError(errors[0].message);
        }
        setLoading(false);
        return;
      }

      gotoNextStep();
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setData({ ...data, isSubmitting: true });
    setLoading(true);
    window.CollectJS.startPaymentRequest();
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
    setDataError((dataError) => ({
      ...dataError,
      [e.target.name]: '',
    }));
  };

  return (
    <div className={className}>
      <div className={`${className}__title`}>
        <h1>Debit card Auto Pay enrollment</h1>
      </div>
      <div className={`${className}__divider`} />
      <form onSubmit={handleSubmit} className={`${className}__form-element`}>
        <div className={`${className}__card-input`}>
          <label className={`${className}__card-input__label`}>Cardholder Name</label>
          <input
            type="text"
            name="name"
            onChange={handleChange}
            value={data.name}
            spellCheck={false}
          />
        </div>
        <div className={`${className}__card-input`}>
          <div className={`${className}__card-input__label`}>Card Number</div>
          <div ref={ccnumberRef} id="ccnumber" />
          {dataError['ccnumber'] && (
            <p className={`${className}__error`}>{dataError['ccnumber']}</p>
          )}
        </div>
        <div className={`${className}__card-input__half`}>
          <div className={`${className}__card-input__label`}>
            Exp. Date{' '}
            <img className={`${className}__card-input__label-img`} src={Info} alt="info" />
          </div>
          <div ref={ccexpRef} id="ccexp" />
          {dataError['ccexp'] && <p className={`${className}__error`}>{dataError['ccexp']}</p>}
        </div>
        <div className={`${className}__card-input__half`}>
          <div className={`${className}__card-input__label`}>
            CVV2 <img className={`${className}__card-input__label-img`} src={Info} alt="info" />
          </div>
          <div ref={cvvRef} id="cvv" />
          {dataError['cvv'] && <p className={`${className}__error`}>{dataError['cvv']}</p>}
        </div>

        {error && <div className={`${className}__error`}>{error}</div>}
        <div className={`${className}__button-container payment margin-top-0`}>
          <button type="submit" disabled={data.isSubmitting}>
            Authorize
          </button>
        </div>
      </form>
      {collectJsLoader && (
        <div className={'collect-js-loading-wrapper'}>
          <BnplLoading className={'bnpl-form'} isAuth />
        </div>
      )}
    </div>
  );
}
